angular
  .module('fca-used')
  .directive('restrictomobile', RestrictToMobileDirective);

/*
to inject log add $log as parameters RestrictToDirective()
RestrictToMobileDirective.$inject = ['$log'];
 */

RestrictToMobileDirective.$inject = ['$log'];

function RestrictToMobileDirective($log) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      var ele = element[0];
      var regex = RegExp('^[0-9]*$');
      var value = ele.value;
      ele.addEventListener('keyup', function (e) {
        if (regex.test(ele.value)) {
          value = ele.value;
        } else {
          ele.value = value;
        }
      });
    }
  };
}
